"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./common/config");
var init_1 = require("./common/init");
var interface_utils_1 = require("@uip-alpha/interface-utils");
/**
 * 从cdn获取静态资源文件
 * @param fileName 请求文件路径 （qs: /assets/config）
 * @param fileName 请求文件名称 （qs: uip-config.json）
 * @param callbackName 请求文件名称的回调 （qs: region_version）
 * @param config jsonp请求相关配置
 */
var getFileFromStatic = function (filePath, fileName, callbackName, config) {
    if (callbackName === void 0) { callbackName = 'cx'; }
    /** 所需业务参数均放置于params中，统一转化 */
    return _this.http
        .jsonp(interface_utils_1.assign({
        url: "" + _this._baseUrl + filePath + "/" + fileName
    }, interface_utils_1.assign({
        opts: {
            name: callbackName
        }
    }), config))
        .then(function (res) { return res; })
        .catch(function () { });
};
/**
 * 发起获取动态配置json数据的配置文件
 * @param fileName 请求文件名称 （qs: uip-config.json）
 * @param callbackName 请求文件名称的回调 （qs: local_region_chn_sc）
 */
var getConfigFromAssets = function (fileName, callbackName, config) {
    if (callbackName === void 0) { callbackName = 'cx'; }
    return getFileFromStatic('/assets/config', fileName, callbackName, config);
};
/**
 * 查询行政区、热门城市地址json数据
 * @param fileName 请求文件名称 （qs: region-chn-sc.json）
 * @param callbackName 请求文件名称的回调 （qs: local_region_chn_sc）
 */
var getRegionFromAssets = function (fileName, callbackName, config) {
    if (callbackName === void 0) { callbackName = 'cx'; }
    return getFileFromStatic('/assets/data/region', fileName, callbackName, config);
};
/**
 * declare 资源
 * @param fileName 请求文件名称 （declare.json）
 * @param callbackName 请求文件名称的回调 （qs: local_region_chn_sc）
 */
var getDeclareFromAssets = function (fileName, callbackName, config) {
    if (callbackName === void 0) { callbackName = 'cx'; }
    return getFileFromStatic('/assets/data/declare', fileName, callbackName, config);
};
exports.default = (function (config) { return function (UIP) {
    /** 前置依赖模块检测 */
    if (!interface_utils_1.beforeInit(UIP)('http'))
        return;
    _this.http = init_1.init(config)(UIP);
    _this._baseUrl = config_1.wxHost[_this.http._env];
    UIP.checkModule('interface', 'assets');
    UIP.interface.assets = {
        getFileFromStatic: getFileFromStatic.bind(_this),
        getConfigFromAssets: getConfigFromAssets.bind(_this),
        getRegionFromAssets: getRegionFromAssets.bind(_this),
        getDeclareFromAssets: getDeclareFromAssets.bind(_this)
    };
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-assets/dist/index.js
// module id = KJni
// module chunks = 1